import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';
import { sendEventToGoogleAnalytics } from '../../../base/analytics/analyticsEvents';

export default class AccordionList extends ComponentBasePrototype {

  build() {
    this.accordionListHeadingSelector = '.accordionlist__heading';
    this.accordionContentSelector = '.accordionlist__content';
    this.accordionWrapperSelector = '.accordionlist__content-wrapper';
    this.accordionItemToggleClass = 'accordionlist__item--open';

    this.setHandlers();
    this.handleAnchorLinks();
    this.scrollToAccordion();

    return true;
  }

  handleAnchorLinks() {
    const anchor = window.location.hash.substr(1);

    if (anchor) {
      this.node.find(`#_${anchor} + div`).trigger('click');
    }
  }

  scrollToAccordion() {
    const accordionHash = window.location.hash.substr(1);
    const targetAccordion = this.node.find(`#_${accordionHash} + div`);
    const shouldScroll = targetAccordion.length > 0;

    if (shouldScroll) {
      const headerHeight = $('#header-wrapper').height();
      const navigationHeight = $('#navigation-wrapper').height();
      const offset = headerHeight + navigationHeight + 20;

      $('html, body').animate({
        scrollTop: (targetAccordion.offset().top) - offset,
      }, 300);
    }
  }

  setHandlers() {
    this.node.find(this.accordionListHeadingSelector).on('click', (event) => {
      this.toggleAccordion($(event.target).closest(this.accordionListHeadingSelector));
    });
  }

  toggleAccordion(item) {
    let targetHeight = 0;
    const contentElement = item.parent().children(this.accordionContentSelector);
    const wrapperElement = contentElement.children(this.accordionWrapperSelector);
  
    if (!item.parent().hasClass(this.accordionItemToggleClass)) {
      // Making the content visible yet still hidden from screen readers and interaction
      contentElement.css({
        'visibility': 'visible',
        'opacity': '0',
        'pointer-events': 'none',
        'max-height': '0'
      });
  
      // Measuring height
      targetHeight = wrapperElement.first().height();
  
      // Now making it interactable and visible
      contentElement.css({
        'opacity': '1',
        'pointer-events': 'auto'
      });
  
      item.attr('aria-expanded', 'true');
    } else {
      item.attr('aria-expanded', 'false');
      contentElement.css({
        'max-height': '0',
        'opacity': '0',
        'pointer-events': 'none'
      });
  
      // After transition, hiding it completely
      contentElement.on('transitionend', function() {
        if (contentElement.css('max-height') === '0px') {
          contentElement.css('visibility', 'hidden');
        }
      });
    }
  
    // Applying the height for animation
    contentElement.css('max-height', targetHeight);
    item.parent().toggleClass(this.accordionItemToggleClass);
  
    if (item.parent().hasClass(this.accordionItemToggleClass)) {
      sendEventToGoogleAnalytics({
        eventCategory: item.data('analyticsgroup'),
        eventAction: 'Välilehden avaaminen',
        eventLabel: item.data('sectiontitle'),
      });
    }
  }
  
}

